import React from 'react';
import { FINAL_CTA, PRICE } from '../constants/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section className="w-full bg-bordo-deep py-12 text-cream b760:py-16" data-id="element-69" data-mp="19ez1nd4q3826">
      <div className="mx-auto max-w-2xl px-4 b720:px-6" data-id="element-70" data-mp="19ga2b42vfzp2">
        <Reveal className="text-center" data-id="element-71" data-mp="15d3zk6eywqnc">
          <span className="inline-block rounded-full border border-mustard/60 bg-mustard/10 px-4 py-1.5 text-xs font-700 uppercase tracking-wide text-mustard b640:text-sm" data-id="element-72" data-mp="15fghijkq710e">
            {FINAL_CTA.badge}
          </span>
          <h2 className="mt-4 font-display text-2xl font-700 uppercase leading-tight text-cream b640:text-4xl" data-id="element-73" data-mp="1t2ydkrb0wl96">
            {FINAL_CTA.title}
          </h2>
        </Reveal>

        <Reveal className="mt-6 space-y-4" data-id="element-74" data-mp="1o4n1sb1640ob">
          {FINAL_CTA.paragraphs.map(paragraph => <p key={paragraph} className="text-sm leading-relaxed text-cream/85 b640:text-base" data-id="element-75" data-mp="223w7ggrqzce1">
              {paragraph}
            </p>)}
        </Reveal>

        <Reveal className="mt-8" data-id="element-76" data-mp="n7p8rlpkhpnh">
          <div className="rounded-2xl border-2 border-mustard bg-bordo px-5 py-7 text-center" data-id="element-77" data-mp="s45s82ltnfu8">
            <p className="text-xs font-700 uppercase tracking-[0.16em] text-mustard b640:text-sm" data-id="element-78" data-mp="x38zzut6s05w">
              {FINAL_CTA.priceLabel}
            </p>
            <p className="mt-1 font-display text-5xl font-700 leading-none text-mustard b640:text-6xl" data-id="element-79" data-mp="1246g81umyk4r">
              {PRICE.today}
            </p>
            <div className="mt-6" data-id="element-80" data-mp="1b31m1ctrps7j">
              <CtaButton data-id="element-81" data-mp="1b28lwupbe0yd">{FINAL_CTA.cta}</CtaButton>
              <p className="mt-2 text-xs text-cream/70" data-id="element-82" data-mp="1fujoy6fcq2v5">{FINAL_CTA.ctaSub}</p>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-8 space-y-4" data-id="element-83" data-mp="1ksbewuwfrewp">
          <p className="text-sm leading-relaxed text-cream/80 b640:text-base" data-id="element-84" data-mp="1kvfok7so72ur">
            {FINAL_CTA.pd}
          </p>
          <p className="text-sm leading-relaxed text-cream/80 b640:text-base" data-id="element-85" data-mp="1tu17i4220jw2">
            {FINAL_CTA.pd2}
          </p>
        </Reveal>
      </div>
    </section>;
}